<template>
    <div class="nav-right" v-show="getVisible()">
        <a class="nr-item" href="javascript:void(0);" @click="openCustomer()" v-bd-track-event="['首页', '点击右侧客服咨询']">
            <i class="el-icon-service"></i>
            <span class="nr-t">客服咨询</span>
        </a>
        <a class="nr-item" href="javascript:void(0);" @click="openFeedback()" v-bd-track-event="['首页', '点击右侧在线反馈']">
            <i class="el-icon-edit"></i>
            <span class="nr-t">在线反馈</span>
        </a>
        <a class="nr-item" href="javascript:void(0);" @click="openHelp()" v-bd-track-event="['首页', '点击右侧帮助中心']">
            <i class="x-icon icon-help"></i>
            <span class="nr-t">帮助中心</span>
        </a>
        <a class="nr-item" href="javascript:void(0);" v-popover:qrcode>
            <i class="x-icon icon-qrcode"></i>
            <span class="nr-t">官方微信</span>
            <el-popover
                ref="qrcode"
                popper-class="nav-r-qrcode"
                placement="left"
                title=""
                width="200"
                trigger="hover">
                <img src="../content/images/qrcode-gzh.jpg" alt="" width="100%">
                <span>关注旋涡官方微信</span>
            </el-popover>
        </a>
        <a class="nr-item" href="javascript:void(0);" @click="backTop()" v-show="backTopVisible">
            <i class="el-icon-arrow-up"></i>
            <span class="nr-t">返回顶部</span>
        </a>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
export default {
    data () {
        return {
            backTopVisible: false
        }
    },
    computed: mapGetters(['getMainDom']),
    mounted () {
        this.getMainDom.onscroll = _.debounce(() => {
            this.backTopVisible = this.getMainDom.scrollTop !== 0;
        }, 150);
    },
    methods: {
        ...mapMutations(['setFeedback']),
        ...mapActions(['verifyStepLogin']),
        getVisible () {
            return /^\/(index|user\/(?!dynamic).+|study\/course|exam|faq)$/.test(this.$route.path);
        },
        openCustomer () {
            let url = 'http://p.qiao.baidu.com/cps/chat?siteId=11200988&userId=24501134';
            window.open(url, '', 'width=800,height=600,left=200,top=100');
        },
        openFeedback () {
            this.verifyStepLogin().then(() => {
                this.setFeedback(true);
            })
        },
        openHelp () {
            this.$router.push({path:"/faq"})
        },
        backTop () {
            this.getMainDom.scrollTop = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
    .nav-right {
        $width: 36px;
        $height: 36px;
        position: fixed;
        top: 60%;
        right: 18px;
        z-index: 2;
        width: $width;
        text-align: center;
        .nr-item {
            position: relative;
            display: block;
            height: $height;
            line-height: $height;
            font-size: $height/2;
            color: #fff;
            background-color: #4999ff;
            overflow: hidden;
            &:hover {
                .nr-t {
                    transform: translate(0) rotate(0);
                }
            }
        }
        .nr-t {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            line-height: $height/2;
            font-size: 13px;
            padding-top: 1px;
            background-color: #5ea5ff;
            transform: translate($width, 0) rotate(90deg);
            transition: all .3s ease-out;
        }
    }
</style>
<style>
    .nav-r-qrcode {
        padding: 0 0 15px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// app/components/NavRight.vue